export default "__VITE_ASSET__CyZlj8Oi__"